import * as styles from "./ToolbarSection.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { ToolbarSectionProps } from "./Toolbar.types";

export function ToolbarSection({
  className,
  ...props
}: ToolbarSectionProps): JSX.Element {
  return (
    <div
      data-slot="toolbar-section"
      className={clsx(styles.section, className)}
      {...props}
    />
  );
}
